import 'pixi-spine';
import '../css/index.css';
import Game from './game';

new Game();
